import { makeStyles, responsiveFontSizes } from '@material-ui/core'

export const containerStyle = makeStyles((theme) => ({
  root: {
    backgroundColor: 'white',
    // margin: '10px 0px',
    [theme.breakpoints.up('sm')]: {
      padding: '15px'
    },
    [theme.breakpoints.down('sm')]: {
      padding: '10px 0px'
    }
  },
  secondReferenceRoot: {
    [theme.breakpoints.up('sm')]: {
      padding: '0px 15px 0px 15px'
    },
    [theme.breakpoints.down('sm')]: {
      padding: '0px'
    }
  },
  unitProfile: {
    borderTop: '1px dashed lightgrey'
  },
  inputField: {
    margin: '21px 0px',
    position: 'relative'
  },
  unitFloor: {
    [theme.breakpoints.up('xs')]: {
      width: '250px'
    },
    [theme.breakpoints.down('xs')]: {
      width: '100%'
    }
  },
  unitDescription: {
    width: '100%'
  },
  evaluatorName: {
    color: '#333333',
    fontSize: '16px',
    fontWeight: 'bold'
  },
  evaluatorEmail: {
    marginTop: '5px',
    color: '#555555',
    fontSize: '14px'
  },
  limit: {
    textAlign: 'right'
  },
  position: {
    [theme.breakpoints.up('xs')]: {
      width: '65%'
    },
    [theme.breakpoints.down('xs')]: {
      width: '100%'
    }
  },

  chargeExperienceLabel: {
    paddingBottom: '15px',
    color: '#333333'
  },
  Name: {
    width: '100%',
    [theme.breakpoints.up('sm')]: {
      width: '93%'
    },
    [theme.breakpoints.up('lg')]: {
      width: '96%'
    }
  },
  NameSecond: {
    width: '100%'
  },
  evaluator: {
    [theme.breakpoints.up('xs')]: {
      width: '100%',
      display: 'flex'
    },
    [theme.breakpoints.down('xs')]: {
      display: 'unset'
    }
  },
  inputFieldName: {
    [theme.breakpoints.up('xs')]: {
      width: '50%'
    },
    [theme.breakpoints.down('xs')]: {
      width: '100%',
      marginBottom: '26px'
    }
  },
  inputFieldNameDropDown: {
    [theme.breakpoints.up('xs')]: {
      width: '50%'
    },
    [theme.breakpoints.down('xs')]: {
      width: '100%',
      marginBottom: '20px'
    }
  },
  inputFieldNameDropDownSmall: {
    [theme.breakpoints.up('xs')]: {
      width: '30%'
    },
    [theme.breakpoints.up('sm')]: {
      width: '40%'
    },
    [theme.breakpoints.up('md')]: {
      width: '40%'
    },
    [theme.breakpoints.up('lg')]: {
      width: '30%'
    },
    [theme.breakpoints.down('xs')]: {
      width: '100%',
      marginBottom: '20px'
    }
  },
  inputFieldNameDropDownLarge: {
    [theme.breakpoints.up('xs')]: {
      width: '50%'
    },
    [theme.breakpoints.up('sm')]: {
      width: '55%'
    },
    [theme.breakpoints.up('md')]: {
      width: '55%'
    },
    [theme.breakpoints.up('lg')]: {
      width: '40%'
    },
    [theme.breakpoints.down('xs')]: {
      width: '100%',
      marginBottom: '20px'
    }
  },
  emailField: {
    [theme.breakpoints.up('xs')]: {
      width: '57%'
    },
    [theme.breakpoints.down('xs')]: {
      width: '100%'
    }
  },
  deletereferencebtn: {
    color: '#0098D8',
    float: 'right',
    marginTop: '-3.5%'
  },
  referencebuttons: {
    marginBottom: '15px',
    color: '#0098D8'
  },
  deleteReferenceButton: {
    color: '#0098D8'
  },
  moreThanThreeReferences: {
    margin: '0px 20px 20px 0px',
    [theme.breakpoints.up('sm')]: {
      margin: '0px 20px 20px 20px'
    }
  },

  referenceheading: {
    font: 'normal normal normal 18px/20px Verdana',
    color: '#333333',
    opacity: '1'
  },

  evaluator_UnitContent: {
    display: 'none'
  },

  seperate_evaluator_unit_Div: {
    top: '966px',
    left: '246px',
    width: '100%',
    height: '0px',
    border: '1px dashed #CCCCCC',
    opacity: '1'
  },

  exceed_msg: {
    font: 'normal normal normal 16px/17px Open Sans',
    color: '#555555',
    opacity: '1'
  },
  separationBorder: {
    borderTop: '2px solid #CCCCCC'
  },
  separationDottedBorder: {
    borderTop: '2px solid #CCCCCC'
  },
  evalution_heading_div: {
    font: 'normal normal normal 16px/20px Verdana',
    color: '#555555',
    opacity: '1',
    marginTop: '2%'
  },
  evalution_para_div: {
    font: 'normal normal normal 14px/17px Open Sans',
    color: '#555555',
    marginTop: '5px',
    opacity: '1'
  },
  eva_typography: {
    marginLeft: '5%'
  },
  evaluation_desc_toggle: {
    marginbottom: '2%'
  },
  eval_compo_div: {
    width: '100%'
  },

  TwoColumnLabelContainer: {
    width: '100%',
    background: '#F8F8F8 0% 0% no-repeat padding-box',
    borderRadius: '2px',
    opacity: 1,
    padding: '12px 16px',
    marginTop: '18px',
    marginBottom: '12px',
    [theme.breakpoints.down('xs')]: {
      // padding: '1.5% 0 0% 0',
      marginBottom: '15px'
    }
  },
  TwoColumnLabel: {
    textAlign: 'left',
    fontFamily: 'sans-serif',
    color: '#555555',
    opacity: 1,
    padding: '4px 0px',
    fontSize: 14,
    [theme.breakpoints.down('xs')]: {
      // padding: '1.5% 0 10% 0',
      fontSize: 12
    }
  },
  listSection: {
    backgroundColor: 'lightgrey',
    border: '1px solid lightgrey',
    margin: '20px 0px',
    [theme.breakpoints.up('sm')]: {
      padding: '10px 30px 10px 30px'
    },
    [theme.breakpoints.down('xs')]: {
      borderRadius: '5px'
    }
  },
  listItem: {
    alignItems: 'flex-center',
    padding: '20px 0px',
    margin: '0px',
    cursor: 'pointer'
  }
}))

export const profileStyle = makeStyles((theme) => ({
  root: {
    [theme.breakpoints.up('sm')]: {
      padding: '40px 10px'
    },
    [theme.breakpoints.down('sm')]: {
      margin: '20px 0px',
      padding: '10px 0px'
    }
  }
}))

export const noBorderContainerStyle = makeStyles((theme) => ({
  root: {
    margin: '10px 0px',
    [theme.breakpoints.up('sm')]: {
      padding: '30px 0px'
    },
    [theme.breakpoints.down('sm')]: {
      padding: '10px 0px'
    }
  }
}))
